import { defineMessages } from 'react-intl';
import { addStyling } from '@plone/volto/helpers/Extensions/withBlockSchemaEnhancer';

const messages = defineMessages({
  defaultFieldset: {
    id: 'Default',
    defaultMessage: 'Default',
  },
  latestNewsSection: {
    id: 'latestNewsSection',
    defaultMessage: 'latest news section',
  },
  items: {
    id: 'items',
    defaultMessage: 'Items',
  },
  item: {
    id: 'item',
    defaultMessage: 'Item',
  },
  showLabel: {
    id: 'showLabel',
    defaultMessage: 'Show tags?',
  },
  noFieldsSelected: {
    id: 'No fields selected',
    defaultMessage: 'No fields selected',
  },
  metadata: {
    id: 'Metadata',
    defaultMessage: 'Metadata',
  },
  simpleList: {
    id: 'Simple list',
    defaultMessage: 'Simple list',
  },
});

const FieldSchema = (intl) => ({
  title: intl.formatMessage(messages.item),
  fieldsets: [
    {
      id: 'default',
      title: intl.formatMessage(messages.defaultFieldset),
      fields: ['item', 'showLabel'],
    },
  ],
  properties: {
    item: {
      title: intl.formatMessage(messages.item),
      widget: 'object_browser',
      mode: 'link',
      return: 'single',
      initialPath: '/de/aktuelles',
      selectableTypes: ['News Item', 'Event', 'Document', 'Folder'],
    },
    showLabel: {
      title: intl.formatMessage(messages.showLabel),
      type: 'boolean',
    },
  },
  required: ['item'],
});

const LatestNewsSchema = (props) => {
  const { intl } = props;
  let schema = {
    title: intl.formatMessage(messages.latestNewsSection),

    fieldsets: [
      {
        id: 'default',
        title: intl.formatMessage(messages.defaultFieldset),
        fields: ['items'],
      },
    ],

    properties: {
      items: {
        title: intl.formatMessage(messages.items),
        schema: FieldSchema(intl),
        widget: 'object_list',
      },
    },

    required: ['items'],
  };

  addStyling({ schema, intl });
  return schema;
};

export default LatestNewsSchema;
